import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess201052Status: 'idle',
    startProcess201052Error: undefined as any,
    loadUserParamsProcess201052Status: 'idle',
    loadUserParamsProcess201052Error: undefined as any,

    process201052List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess201052 = createAsyncThunk('process201052Slice/startProcess201052', async ({ process201052 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess201052/`,
        prepareData(process201052),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess201052Status } = getState().process201052Slice
        return startProcess201052Status !== 'pending'
    }
})

export const loadUserParamsProcess201052 = createAsyncThunk('process201052Slice/loadUserParamsProcess201052', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess201052/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess201052Status } = getState().process201052Slice
        return loadUserParamsProcess201052Status !== 'pending'
    }
})

const Process201052Slice = createSlice({
    name: 'process201052Slice',
    initialState,
    reducers: {
        resetstartProcess201052: (state) => {
            state.job = undefined
            state.startProcess201052Error = undefined
        },
        resetstartProcess201052Error: (state) => {
            state.startProcess201052Error = undefined
        },
        resetloadUserParamsProcess201052: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess201052Error = undefined
        },
        resetloadUserParamsProcess201052Error: (state) => {
            state.loadUserParamsProcess201052Error = undefined
        },
        removeFromProcess201052ListById: (state, action) => {
            state.process201052List = state.process201052List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess201052ListByIds: (state, action) => {
            state.process201052List = state.process201052List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process201052List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess201052Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process201052List = []
            state.startProcess201052Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess201052.pending, (state) => {
            state.startProcess201052Status = 'pending'
            state.startProcess201052Error = undefined
        })
        builder.addCase(startProcess201052.fulfilled, (state, action) => {
            state.startProcess201052Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess201052.rejected, (state, action) => {
            state.startProcess201052Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess201052Error = action.error.message
            } else {
                state.startProcess201052Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess201052.pending, (state) => {
            state.loadUserParamsProcess201052Status = 'pending'
            state.loadUserParamsProcess201052Error = undefined
        })
        builder.addCase(loadUserParamsProcess201052.fulfilled, (state, action) => {
            state.loadUserParamsProcess201052Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess201052.rejected, (state, action) => {
            state.loadUserParamsProcess201052Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess201052Error = action.error.message
            } else {
                state.loadUserParamsProcess201052Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess201052,
    resetstartProcess201052Error,
    resetloadUserParamsProcess201052,
    resetloadUserParamsProcess201052Error,
    removeFromProcess201052ListById,
    removeFromProcess201052ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process201052Slice.actions
export default Process201052Slice.reducer
